import { useRef, useState } from "react";
import { ImageIcon, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const ImageUpload = ({ value, onChange, teamId, testid, wide, contain }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("Image is too large — max 5 MB");
    const fd = new FormData();
    fd.append("file", file);
    if (teamId) fd.append("team_id", teamId);
    setBusy(true);
    try {
      const { data } = await api.post("/uploads", fd);
      onChange(data.url);
      toast.success("Image uploaded — remember to save");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <div className={`flex shrink-0 items-center justify-center overflow-hidden rounded-md border border-white/10 bg-white/5 ${wide ? "h-16 w-28" : "h-16 w-16"}`}>
        {value ? <img src={value} alt="Uploaded" className={`h-full w-full ${contain ? "object-contain bg-white p-1" : "object-cover"}`} data-testid={`${testid}-preview`} /> : <ImageIcon className="h-6 w-6 text-slate-500" />}
      </div>
      <div className="flex flex-wrap gap-2">
        <Button type="button" size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} className="rounded-full border-white/15 bg-transparent" data-testid={`${testid}-upload-btn`}>
          <Upload className="mr-1 h-3.5 w-3.5" />{busy ? "Uploading…" : value ? "Replace" : "Upload image"}
        </Button>
        {value && <Button type="button" size="sm" variant="ghost" onClick={() => onChange("")} className="text-slate-400" data-testid={`${testid}-remove-btn`}><X className="mr-1 h-3.5 w-3.5" /> Remove</Button>}
      </div>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/gif,image/x-icon" className="hidden" onChange={pick} data-testid={`${testid}-file-input`} />
    </div>
  );
};
